import { render, staticRenderFns } from "./HistoricalAgreementList.vue?vue&type=template&id=7c44db26&scoped=true"
import script from "./HistoricalAgreementList.vue?vue&type=script&lang=js"
export * from "./HistoricalAgreementList.vue?vue&type=script&lang=js"
import style0 from "./HistoricalAgreementList.vue?vue&type=style&index=0&id=7c44db26&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c44db26",
  null
  
)

export default component.exports